module.exports = __webpack_public_path__ + "img/bg_02.dd34ee70.jpg";